export default [
  {
    path: '/',
    redirect: 'loan'
  },
  {
    text: 'Loan',
    path: 'loan',
    name: 'loan',
    component: () => import(/* webpackChunkName: "loansettings" */ '@/views/settings/Loan.vue')
  },
  {
    text: 'Apis',
    path: 'apis',
    name: 'apis',
    component: () => import(/* webpackChunkName: "apisettings" */ '@/views/settings/Apis.vue')
  }
]
